module.exports = __webpack_public_path__ + "img/company_logo.c0a9757c.png";